module.exports = __webpack_public_path__ + "static/img/tip-6.19d3309.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-6.png
// module id = 62Xp
// module chunks = 1